import {
  Component,
  OnInit,
  Output,
  ViewChild,
  EventEmitter,
  Input
} from "@angular/core";
import { DataListModel } from "../../shared/config";
import {
  CostTypeModel,
  DefaultCostTypeList
} from "../models/cost-center-report.model";
import { CostCenterReportService } from "../models/cost-center-report.service";
import { AuthService } from "../../shared/models/auth.service";
import { Router } from "@angular/router";
import { TranslateService } from "../../shared/translate";

@Component({
  selector: "select-costtype-popup",
  template: require('../views/select-costtype-popup.component.html'),
  providers: [CostCenterReportService]
})
export class SelectCostTypePopupComponent implements OnInit {
  SelectedNames: string[] = [];
  SelectedList: string[] = [];
  costTypeList: CostTypeModel[] = [];
  message: string;
  apiErrorMsg: string;
  isLoading: boolean;
  LblIcon: string = "fa fa-plus-square";
  isParentCheck: boolean = false;

  @Input("PageName") pageName: string;
  @Output("OnSuccessSelect") onCostTypeSelect = new EventEmitter();
  @ViewChild("costTypeModal") public costTypeModal: any;

  constructor(
    private costCenterReportService: CostCenterReportService,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {}

  public show(SelectedList: string[], SelectedNamesList: string[]): void {
    this.SelectedList = SelectedList;
    this.SelectedNames = SelectedNamesList;

    if (SelectedList.length == 0) {
      this.SelectedList = DefaultCostTypeList.map(x => x.costTypeHashId);
      this.SelectedNames = DefaultCostTypeList.map(x => x.name);
    }
    
    this.GetCostTypeList();
    this.costTypeModal.show();
  }

  public hide(): void {
    this.costTypeModal.hide();
  }

  private GetCostTypeList() {
    this.isLoading = true;
    this.costCenterReportService.GetCostTypeList("", this.pageName).subscribe(
      res => {
        this.costTypeList = res.data;

        DefaultCostTypeList.forEach(x => this.costTypeList.push(x));

        this.costTypeList.forEach(
          x => (x.isChecked = this.SelectedList.indexOf(x.costTypeHashId) > -1)
        );

        this.isParentCheck = this.costTypeList.every(x => x.isChecked);
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  private ItemCheckChanged(
    defaultName: string,
    costTypeHashId: string,
    costTypeName: string,
    isChecked: any
  ) {
    if (isChecked) {
      if (this.SelectedList.indexOf(costTypeHashId) == -1) {
        this.SelectedList.push(costTypeHashId);
      }
      if (this.SelectedNames.indexOf(costTypeName) == -1) {
        this.SelectedNames.push(costTypeName);
      }
      this.isParentCheck = this.costTypeList
        .filter(x => x.costTypeHashId != costTypeHashId)
        .every(x => x.isChecked);
    } else {
      this.SelectedList = this.SelectedList.filter(x => x != costTypeHashId);
      this.SelectedNames = this.SelectedNames.filter(x => x != costTypeName);
      this.isParentCheck = false;
    }
  }

  public OnParentCheck(isChecked: boolean) {
    this.costTypeList.forEach(x => {
      x.isChecked = isChecked;
      if (isChecked) {
        if (this.SelectedList.indexOf(x.costTypeHashId) == -1) {
          this.SelectedList.push(x.costTypeHashId);
        }
        if (this.SelectedNames.indexOf(x.name) == -1) {
          this.SelectedNames.push(x.name);
        }
      } else {
        this.SelectedList = this.SelectedList.filter(
          y => y != x.costTypeHashId
        );
        this.SelectedNames = this.SelectedNames.filter(y => y != x.name);
      }
    });
  }

  private select(costType: CostTypeModel): void {
    this.isLoading = true;
    this.onCostTypeSelect.emit({
      CostTypeHashId: costType.costTypeHashId,
      CostTypeName: costType.name
    });
    this.isLoading = false;
    this.hide();
  }

  private selectMultiple(): void {
    this.isLoading = true;
    this.onCostTypeSelect.emit({
      CostTypeHashId: this.SelectedList,
      CostTypeName: this.SelectedNames
    });
    this.isLoading = false;
    this.hide();
  }

  private CostTypeSelectModal() {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/report/components/select-costtype-popup.component.ts